// import Link from 'next/link'

import { format } from 'util'

import { useEffect, useState } from 'react'

import { ReactSVG } from 'react-svg'

import InputWithCopy from '../../../../components/ui/input-with-copy'

import ButtonBlue from '../../../../components/ui/button/_color/_blue'

import { requestUserReferral } from '../../../../store/fetchers/users'

import Popup from '../../../../components/ui/popup'

import { floorNumber } from '../../../../utils/floor-number'

import styles from './styles.module.scss'
import { ReferralCodeProps } from './referral-code.props'

import SocialIcon1 from './icons/social-1.svg'
import SocialIcon2 from './icons/social-2.svg'
import SocialIcon3 from './icons/social-3.svg'
import SocialIcon4 from './icons/social-4.svg'
import SuccessIcon from './icons/success.svg'
import WithdrawIcon from './icons/withdraw-icon.svg'
import WarnIcon from './icons/warn.svg'
import { useTranslation } from 'utils/use-translation'

export default function ReferralCode({ userReferrals, getUserReferralsData }: ReferralCodeProps) {
  const { t } = useTranslation()
  
  const [totalProfit, setTotalProfit] = useState<number>(0)
  const [isWithdrawErr, setIsWithdrawErr] = useState<boolean>(false)
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false)

  const withdraw = async () => {
    try {
      await requestUserReferral()
      await getUserReferralsData()
      setIsPopupVisible(true)
    } catch (err) {
      setIsWithdrawErr(true)
    }
  }

  const closePopup = () => {
    setIsPopupVisible(false)
  }

  useEffect(() => {
    if (userReferrals) {
      setTotalProfit(
        userReferrals.loans
          ?.filter((el) => Number(el.profit) >= 0)
          ?.reduce((acc, cur) => (acc += Number(cur.profit)), 0),
      )
    }
  }, [userReferrals])

  const shareViaTelegram = () => {
    const message = encodeURIComponent(
      `Visit CoinRabbit and get extra crypto in 15 minutes by registering through my link!`,
    )
    // Используем веб-ссылку для Telegram
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(
      'https://coinrabbit.io/?referral=' + userReferrals?.referral_code,
    )}&text=${message}`

    // Открываем Telegram
    window.open(telegramUrl, '_blank')
  }

  const shareViaTwitter = () => {
    const text = `Visit CoinRabbit and get extra crypto in 15 minutes by registering through my link!`
    const referralLink = `https://coinrabbit.io/?referral=${userReferrals?.referral_code}`

    // Ссылка для твита
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(
      referralLink,
    )}`

    // Открываем ссылку
    window.open(twitterUrl, '_blank')
  }

  const shareViaFacebook = () => {
    const referralLink = `https://coinrabbit.io/?referral=${userReferrals?.referral_code}`

    // Ссылка для шеринга в Facebook
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`

    // Открываем ссылку
    window.open(facebookUrl, '_blank')
  }

  const shareViaLinkedIn = () => {
    const referralLink = `https://coinrabbit.io/?referral=${userReferrals?.referral_code}`
    const text = `Visit CoinRabbit and get extra crypto in 15 minutes by registering through my link!`

    // Ссылка для шеринга в LinkedIn
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      referralLink,
    )}&title=${encodeURIComponent(text)}`

    // Открываем ссылку
    window.open(linkedInUrl, '_blank')
  }

  return (
    <div className={styles.referralCode}>
      <div className={styles.referralCode__left}>
        <h3>{t('your_referral_link')}</h3>
        {userReferrals && (
          <InputWithCopy
            inputClassName={styles.input}
            className={styles.inputWrapper}
            valueDisplay={
              userReferrals && userReferrals?.referral_code
                ? `https://coinrabbit.io/?referral=${userReferrals?.referral_code}`
                : ``
            }
            content={
              userReferrals && userReferrals?.referral_code
                ? `https://coinrabbit.io/?referral=${userReferrals?.referral_code}`
                : ``
            }
            isReadonly={true}
            isAllActive={true}
          />
        )}

        <div className={styles.share}>
          <p>{t('share')}</p>

          <div className={styles.images}>
            <ReactSVG src={SocialIcon1} className={styles.image} onClick={shareViaTwitter} />
            <ReactSVG src={SocialIcon2} className={styles.image} onClick={shareViaTelegram} />
            <ReactSVG src={SocialIcon3} className={styles.image} onClick={shareViaFacebook} />
            <ReactSVG src={SocialIcon4} className={styles.image} onClick={shareViaLinkedIn} />
          </div>
        </div>
      </div>

      <div className={styles.referralCode__right}>
        <div className={styles.data}>
          <div className={styles.data__item}>
            <p>{t('ready_to_withdraw')}</p>
            {userReferrals && (
              <span>
                {format(
                  floorNumber(Number(userReferrals?.reward?.loans), 6) > 0
                    ? floorNumber(Number(userReferrals?.reward?.loans), 6)
                    : 0,
                )}{' '}
                USDT
              </span>
            )}
          </div>

          <div className={styles.data__item}>
            <p>{t('total_profit')}</p>
            {totalProfit && <span>{format(floorNumber(totalProfit, 6))} USDT</span>}
          </div>
        </div>

        <button
          className={styles.withdrawBtn}
          disabled={floorNumber(Number(userReferrals?.reward?.loans), 6) < 10}
          onClick={withdraw}
        >
          <ReactSVG className={styles.withdrawBtn__img} src={WithdrawIcon} />
          <p>{t('withdraw')}</p>
        </button>
      </div>

      {isPopupVisible && (
        <Popup heading={t('withdrawal_requested')} className={styles.popup} onClose={closePopup}>
          <div className={styles.main}>
            <img src={SuccessIcon} alt="success icon" />
            <p>
              {t('withdrawal_request_sent')}
            </p>
          </div>
          <ButtonBlue className={styles.popupBtn} onClick={closePopup}>{t('done')}</ButtonBlue>
        </Popup>
      )}

      {isWithdrawErr && (
        <Popup heading={t('something_went_wrong')} className={styles.popup_warn} onClose={() => setIsWithdrawErr(false)}>
          <div className={styles.main_warn}>
            <img src={WarnIcon} alt="warning icon" />
            <p>{t('try_later_reloan_page')}</p>
          </div>
          <ButtonBlue className={styles.popupBtn_warn} onClick={() => setIsWithdrawErr(false)}>{t('got_it')}</ButtonBlue>
        </Popup>
      )}
    </div>
  )
}
